import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import api from '@/api';
import Generate from './generate';
export default {
  name: 'GenerateTable',
  components: {
    Generate: Generate
  },
  data: function data() {
    return {
      initform: {
        rootPkg: '1',
        feignServiceName: '1',
        prefix: '1',
        tableName: '1'
      },
      dialogVisible: false,
      tableData: [],
      formInline: {
        mysqlUrl: 'localhost:3306',
        userName: 'root',
        passWord: 'wangyang119',
        dbName: 'unbox_admin',
        mysqlDev: 'com.mysql.cj.jdbc.Driver',
        tableName: ''
      }
    };
  },
  methods: {
    generateClose: function generateClose() {
      this.dialogVisible = false;
    },
    generate: function generate(index, data) {
      this.dialogVisible = true;
      this.formInline.tableName = data.tableName;
      this.formInline.tableComment = data.tableComment;
      this.$refs.generate.initTableData(this.formInline);
    },
    getTableList: function getTableList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              localStorage.setItem('generateConfig', JSON.stringify(_this.formInline));
              _this.formInline.tableName = '';
              _context.n = 1;
              return api.GET_TABLE_LIST(_this.formInline);
            case 1:
              data = _context.v;
              _this.tableData = data.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    var config = localStorage.getItem('generateConfig');
    if (config !== null) {
      this.formInline = JSON.parse(config);
    }
  }
};